module.exports = __webpack_public_path__ + "img/ltkfitness-4x.071f5c0.jpg";